import axios from '../utils/axios';

export default function getClusters(recId, params) {
    return (
        axios.get('/admin/' + recId + '/companyManagement/v1/clusters', { params })
        .then(res => {
            return res.data
        })
        .catch(err => {
            return err;
        })
    )
}
